// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"5895":"4255e36b","6093":"9dfe302d"}[chunkId] + ".css";
};